import { render, staticRenderFns } from "./List.vue?vue&type=template&id=c9f5a24a&scoped=true&"
import script from "./List.vue?vue&type=script&lang=js&"
export * from "./List.vue?vue&type=script&lang=js&"
import style0 from "./List.vue?vue&type=style&index=0&id=c9f5a24a&prod&scoped=true&lang=css&"
import style1 from "./List.vue?vue&type=style&index=1&id=c9f5a24a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9f5a24a",
  null
  
)

export default component.exports